export const colors = {
  buttons: {
    primary: '#91470D',
    primaryHover: '#5A3006',
    secondary: '#C47E13',
    secondaryHover: '#CF8F2C',
    dark: '#402C18',
    darkHover: '#301800',
    light: '#CDA768',
    text: '#FFF5E3',
  },
  text: {
    dark: '#402C18',
    black: '#231201', // Figma "Text/Black" — largest values + table headers
    accent: '#87501A',
    light: '#FFEEE3', // Figma "Text/Light"
    // INTENTIONAL deviation from DS "Text/Active" (#91692B): kept as the gold
    // accent (= Buttons/Secondary) — component mockups show the active-tab
    // underline in #C47E13, and the DS Text/Active token isn't used here.
    // Decision 2026-06-03; do not "sync" to #91692B.
    active: '#C47E13',
    accentGreen: '#505F17', // Figma "Text/Accent green" — APR / positive yield
    accentRed: '#803500', // Figma "Text/Accent red" — monetary emphasis ($/day, claimable)
  },
  background: {
    light: '#EAD1A3',
    dark: '#402C18',
    accent: '#CDA768',
    // Figma outer-card surface: Background/Accent @88% — translucent over the
    // page bg image (that's how the design builds depth; flat #EAD1A3 hides it).
    card: 'rgba(205, 167, 104, 0.88)',
    medium: '#C69D59',
    transparent: '#D4A24E7A', // = Figma "Background/Transparent" — My Bonds container
    tooltip: '#FAEBD1',
  },
  elements: {
    primary: '#E6B25D',
    primaryHover: '#E7BC75',
    dark: '#402C18',
    skeletonPrimary: '#B27D28',
    skeletonSecondary: '#F4C06C',
    accent: '#87501A',
  },
  border: {
    primary: '#402C18',
    secondary: '#BB9049', // Figma "Border/Secondary" — lighter gold card border
    separator: 'rgba(64, 44, 24, 0.3)',
  },
  gradient: {
    fade: 'linear-gradient(90deg, #402C18 40.38%, rgba(166, 114, 62, 0) 100%)',
  },
  accent: {
    success: '#387545',
    error: '#E5373A',
    soft: '#FFEBC3',
  },
  tags: {
    // Redeem-status pills. INTENTIONAL deviation from the DS palette's
    // Tags/Processing #7FB1B6 / Success #CCCC57 / Reject #E08B76 (teal/olive/
    // salmon): we use the semantic Accent colours from the table mockup
    // (19977:5400 / 21721:10493) because green=accepted / red=canceled reads
    // clearer. Decision 2026-06-03; do not "sync" to the DS Tags/* values.
    processing: '#FFEBC3', // Accent/Soft (Pending) — dark text
    success: '#387545', // Accent/Success (Accepted) — light text
    reject: '#E5373A', // Accent/Error (Canceled) — light text
    // Mint/Transfer action pills — Figma "Tags/*".
    transfer: '#AF7B13', // Figma "Tags/Transfer"
    mint: '#505F17', // Figma "Tags/Mint"
    text: '#FFFFFF', // Figma "Tags/Text" — white on the colored action pills
  },
};
